// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tip-icon-big {\n  color: #FAAD14;\n  font-size: 48px;\n}\n.tip-isRealNameNo {\n  font-weight: bold;\n  font-size: 15px;\n  color: #333333;\n  line-height: 21px;\n  text-align: center;\n  padding: 0 90px;\n}\n", ""]);
// Exports
module.exports = exports;
